import { Text } from '@zillow/constellation-10';

import { VERTICAL_DISPLAY_TYPE } from '../../../../constants/PropertiesConstants';

import ApplicationShareLinks from '../ApplicationShareLinks';
import SimpleCard from '../../../SimpleCard';

type Props = {
  displayType?: VERTICAL_DISPLAY_TYPE;
};

const EmptyApplicationsCardSimple = ({ displayType = VERTICAL_DISPLAY_TYPE.FULL }: Props) => {
  return (
    <SimpleCard data-testid="EmptyApplicationsCardSimple">
      <Text asChild textStyle="body-bold">
        <p>You don&apos;t have any applications yet</p>
      </Text>

      <Text asChild textStyle="body-sm" css={{ marginBottom: '400' }}>
        <p>You can invite renters to apply or wait for renters to apply via your listing on Zillow Rental Network.</p>
      </Text>

      <ApplicationShareLinks displayType={displayType} />
    </SimpleCard>
  );
};

export default EmptyApplicationsCardSimple;
